/**
 * 
 * @param {string} module module item id
 * @returns {string} module script path
 */
export const moduleMapping = (module) => {
  const moduleMap = {
    'customer-service-chat': 'customer-service/chat/Chat.vue',
  }
  
  return moduleMap[module]
}